import React, { useEffect, useState } from "react";
import L from "leaflet"; // Импорт библиотеки Leaflet
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
import { getCookie } from "typescript-cookie";
import KyLokal from "../../changeLang/drawLocalesKy";
import RuLokal from "../../changeLang/drawLocalesRu";
import styles from "./styles_map.module.css";

interface IContentPart {
  latitude: number;
  longitude: number;
}

const markers = [
  {
    latitude: 42.8887935,
    longitude: 74.621926,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Кыргыз Агро Вет сервис»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Поставка комбикорма, кормовые концентраты, премиксы для животных, биопрепараты, СЗР, семена зерновых культур из Азии и Китая.<br />
        <strong>Адрес:</strong> г.Бишкек, ул. Дунайская, 24<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 42.8588447,
    longitude: 74.5973159,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Кыргыз Агро Кемикалс»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Поставка средств защиты растений и ветеринарные препараты из Центральной Азии, Узбекистана, Таджикистана<br />
        <strong>Адрес:</strong> г. Бишкек, пер. Ашхабадский, 15<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 42.8712623,
    longitude: 74.5628256,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Агрохимия»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Поставка органических удобрений, инсектицидов, гербицидов из Центральной/Восточной Европы, Центральной Азии, Азии, России, Казахстана, Китая, Украины<br />
        <strong>Адрес:</strong> г. Бишкек, ул. Московская, 266 (пер. ул. Фучика, 2а)<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.0542718,
    longitude: 70.8170568,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО»ЕвроСервис Групп»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Проектирование, устанавливание системы капельного орошения и строительство геомембранных резервуаров (БДР, БСР), устанавливление насосных, фильтрационных, фертигационных узлов.<br />
        <strong>Адрес:</strong> Баткенская область, г. Баткен, ул. Салихова, 41<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.2516891,
    longitude: 72.0583561,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Пестициды»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Оптовая и розничная торговля высококачественными и эффективными средствами защиты растений. Удобрения (Гумат, Заргрин и др.), Фунгициды (Премикур, Пиразол, Клеопатра и др.), регулятор роста (Новосил, Бигус и др.). <br />
        <strong>Адрес:</strong> Баткенская область, Кадамжайский район, с. Уч-Коргон<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.4894846,
    longitude: 78.3901249,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Пестициды»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Оптовая и розничная торговля высококачественными и эффективными средствами защиты растений. Удобрения (Гумат, Заргрин и др.), Фунгициды (Премикур, Пиразол, Клеопатра и др.), регулятор роста (Новосил, Бигус и др.).  <br />
        <strong>Адрес:</strong> Иссык-Кульская область, г.Каракол, ул. Жамансариева, 175<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.8962302,
    longitude: 72.9040102,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Бай Дыйкан»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong> Для поддержки фермеров Кыргызстана функционирует 6 центров поддержки фермеров. Ежегодно компания поставляет около 200 тыс. тонн удобрений из Узбекистана, стран СНГ и др. стран. Кроме этого, компания обеспечивает фермеров семенами, саженцами и препаратами по ветеринарии. <br />
        <strong>Адрес:</strong> Жалал-Абадская область, Сузакский район, с.Сузак, ул. Дакан-Палван, 193<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.9291749,
    longitude: 72.9835997,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Жалал-Абад сельхоз химия»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong>Поставка органических удобрений <br />
        <strong>Адрес:</strong> Жалал-Абадская область, г. Жалал-Абад, ул. Строителей, 154<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.6992866,
    longitude: 72.8696723,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Бай Дыйкан»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong>Для поддержки фермеров Кыргызстана функционирует 6 центров поддержки фермеров. Ежегодно компания поставляет около 200 тыс. тонн удобрений из Узбекистана, стран СНГ и др. стран. Кроме этого, компания обеспечивает фермеров семенами, саженцами и препаратами по ветеринарии. <br />
        <strong>Адрес:</strong> Ошская область, Кара-Сууйский район, г. Кара-Суу<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.5112362,
    longitude: 72.8106616,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Фаиз Кемикал»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong>Оптовая и розничная поставка качественных средств защиты растений (пестицидов) из Китая и Азии. <br />
        <strong>Адрес:</strong> Ошская область, г. Ош, ул.Ленина 167-1<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.5502268,
    longitude: 72.7843335,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Крастекс»</h3>
      <p style="margin: 4px 0;">
        <strong>Направление деятельности :</strong>Поставка удобрений и средств защиты растений <br />
        <strong>Адрес:</strong> Ошская область, г. Ош, ул. Ленина, 710(б)<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.532515,
    longitude: 72.2112957,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Областная станция химизации и защиты растений</h3>
      <p style="margin: 4px 0;">

        <strong>Адрес:</strong> Таласская область, г. Талас, ул. Мадиева, 2<br />
      </p>
      </div>
    `,
  },

];
const customMarkerIcon = L.icon({
  iconUrl: "/Supp.svg",
  iconSize: [35, 55],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const SupplierMap = (props: IContentPart) => {
  (L as any).drawLocal = getCookie("i18next") === "ky" ? KyLokal : RuLokal;

  const [geoData, setGeoData] = useState<any>(null);
  const [bishkekGeoData, setBishkekGeoData] = useState<any>(null);
  const [batkenGeoData, setBatkenGeoData] = useState<any>(null);
  const [chuiGeoData, setChuiGeoData] = useState<any>(null);
  const [issikulGeoData, setIssikulGeoData] = useState<any>(null);
  const [jalalabadGeoData, setJalalabadGeoData] = useState<any>(null);
  const [narinGeoData, setNarinGeoData] = useState<any>(null);
  const [oshGeoData, setOshGeoData] = useState<any>(null);
  const [oshoblGeoData, setOshoblGeoData] = useState<any>(null);
  const [talasGeoData, setTalasGeoData] = useState<any>(null);
  useEffect(() => {
    const fetchGeoData = async (
      file: string,
      setGeoData: React.Dispatch<React.SetStateAction<any>>,
      label: string
    ) => {
      try {
        const response = await fetch(`/${file}`);
       
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        } else {
          console.warn(
            `Данные geojson отсутствуют или неверный формат в ${label}:`,
            data
          );
        }
      } catch (error) {
       
      }
    };

  

    fetchGeoData("polygons/search.json", setGeoData, "polygons/search.json");
    fetchGeoData(
      "polygons/bishkek.json",
      setBishkekGeoData,
      "polygons/bishkek.json"
    );
    fetchGeoData(
      "polygons/batken.json",
      setBatkenGeoData,
      "polygons/batken.json"
    );
    fetchGeoData("polygons/chui.json", setChuiGeoData, "polygons/chui.json");
    fetchGeoData(
      "polygons/issikul.json",
      setIssikulGeoData,
      "polygons/issikul.json"
    );
    fetchGeoData(
      "polygons/jalalabad.json",
      setJalalabadGeoData,
      "polygons/jalalabad.json"
    );
    fetchGeoData("polygons/narin.json", setNarinGeoData, "polygons/narin.json");
    fetchGeoData("polygons/osh.json", setOshGeoData, "polygons/osh.json");
    fetchGeoData(
      "polygons/oshobl.json",
      setOshoblGeoData,
      "polygons/oshobl.json"
    );
    fetchGeoData("polygons/talas.json", setTalasGeoData, "polygons/talas.json");
  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  return (
    <MapContainer
      className={styles.map}
      center={[41.5089324, 74.724091]}
      zoom={7}
      minZoom={7}
      scrollWheelZoom={true}
      zoomControl={false}
    >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* {geoData && (
        <GeoJSON
          data={geoData}
          style={getStyle("blue")}
          onEachFeature={onEachFeature}
        />
      )} */}

      {markers.map((marker, index) => (
        <Marker
          key={index}
          position={[marker.latitude, marker.longitude]}
          icon={customMarkerIcon}
        >
          <Popup>
            <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
          </Popup>
        </Marker>
      ))}
           {/* {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />} */}
           {bishkekGeoData && <GeoJSON data={bishkekGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {batkenGeoData && <GeoJSON data={batkenGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {chuiGeoData && <GeoJSON data={chuiGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {issikulGeoData && <GeoJSON data={issikulGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {jalalabadGeoData && <GeoJSON data={jalalabadGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {narinGeoData && <GeoJSON data={narinGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {/* {oshGeoData && <GeoJSON data={oshGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />} */}
      {oshoblGeoData && <GeoJSON data={oshoblGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {talasGeoData && <GeoJSON data={talasGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
    </MapContainer>
  );
};
